export default "__VITE_ASSET__2qCMwDAd__"